module.exports = __webpack_public_path__ + "img/d7b3bc5.png";